var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiVisareq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107283",
    "data-name": "Group 107283",
    transform: "translate(-437 -586)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40439",
    "data-name": "Rectangle 40439",
    width: 32,
    height: 32,
    transform: "translate(437 586)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106166",
    "data-name": "Path 106166",
    d: "M8,1A2,2,0,0,0,6,3V31a2,2,0,0,0,2,2H29.333a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2ZM18.667,6.333a7.333,7.333,0,1,1-7.333,7.333A7.341,7.341,0,0,1,18.667,6.333ZM18,7.9c-.961.625-1.846,2.523-1.979,5.1H18Zm1.333,0V13h1.979C21.18,10.419,20.294,8.521,19.333,7.9Zm-3.479.479A6.018,6.018,0,0,0,12.708,13h1.979A10.614,10.614,0,0,1,15.854,8.375Zm5.625,0A10.614,10.614,0,0,1,22.646,13h1.979A6.011,6.011,0,0,0,21.479,8.375Zm-8.771,5.958a6.018,6.018,0,0,0,3.146,4.625,10.614,10.614,0,0,1-1.167-4.625Zm3.313,0c.133,2.581,1.018,4.479,1.979,5.1v-5.1Zm3.312,0v5.1c.961-.622,1.846-2.523,1.979-5.1Zm3.313,0a10.614,10.614,0,0,1-1.167,4.625,6.018,6.018,0,0,0,3.146-4.625ZM10.667,25.667h16a.667.667,0,0,1,0,1.333h-16a.667.667,0,0,1,0-1.333Z",
    transform: "translate(434.333 585)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiVisareq);
export default __webpack_public_path__ + "static/media/visionai_visareq.c2b6d72db8377018750671c65a73230f.svg";
export { ForwardRef as ReactComponent };